import {
  createContext,
  type FC,
  type ReactNode,
  type RefObject,
  useCallback,
  useMemo,
  useRef,
} from 'react';
import type {FormValidations} from '~/common/FabricInvitation/types';

interface FabricInvitationContextType {
  isPremiumOnMount: boolean;
  formValidations: RefObject<FormValidations>;
  setFormValidations: (validations: (current: FormValidations) => FormValidations) => void;
}

const defaultContextValue: FabricInvitationContextType = {
  isPremiumOnMount: false,
  formValidations: {current: {}},
  setFormValidations: () => null,
};

export const FabricInvitationContext =
  createContext<FabricInvitationContextType>(defaultContextValue);

interface FabricInvitationContextParentProps {
  children: ReactNode;
}

export const FabricInvitationContextParent: FC<FabricInvitationContextParentProps> = ({
  children,
}) => {
  const formValidations = useRef<FormValidations>({});

  const setFormValidations = useCallback(
    (validations: (current: FormValidations) => FormValidations) => {
      formValidations.current = validations(formValidations.current);
    },
    []
  );

  const contextValue: FabricInvitationContextType = useMemo(
    () => ({
      isPremiumOnMount: window.evite_event?.is_fabric_premium ?? window.fabricTemplate.premium,
      formValidations,
      setFormValidations,
    }),
    [setFormValidations]
  );

  return (
    <FabricInvitationContext.Provider value={contextValue}>
      {children}
    </FabricInvitationContext.Provider>
  );
};
